import React, { useRef } from "react";
import DataTable from "react-data-table-component";
import ClipLoader from "react-spinners/ClipLoader";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { TbEdit, TbSettings } from "react-icons/tb";
import { IoMdSearch } from "react-icons/io";

import styles from "@areas/shared/pages/personal/frames/statistics/contracts/blocks/styles/allTable.module.css";

function formatHolland(row) {
  const parts = [
    ["R", row.HollandR],
    ["I", row.HollandI],
    ["A", row.HollandA],
    ["S", row.HollandS],
    ["E", row.HollandE],
    ["C", row.HollandC],
  ]
    .filter(([, value]) => value != null && Number(value) > 0)
    .map(([key, value]) => `${key}:${Number(value).toFixed(2)}`);

  return parts.length ? parts.join(" ") : "—";
}

function Table({
  load,
  data,
  total,
  handlePageChange,
  handlePerRowsChange,
  toggleModal,
  onSearch,
}) {
  const searchRef = useRef();
  const paginationOptions = {
    rowsPerPageText: "Данных на странице:",
    rangeSeparatorText: "из",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "Все",
  };
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">ID</span>,
      selector: (row) => row.Id,
      sortable: true,
      width: "6%",
    },
    {
      name: <span className="font-weight-bold fs-13">Источник</span>,
      selector: (row) => row.SourceSpecialist || "—",
      sortable: true,
      width: "18%",
      wrap: true,
    },
    {
      name: <span className="font-weight-bold fs-13">ОКЗ</span>,
      selector: (row) =>
        [row.OkzCode, row.OkzTitle].filter(Boolean).join(" ") || "—",
      sortable: true,
      width: "18%",
      wrap: true,
    },
    {
      name: <span className="font-weight-bold fs-13">ОКСО</span>,
      selector: (row) =>
        [row.OksoCode, row.OksoTitle].filter(Boolean).join(" ") || "—",
      sortable: true,
      width: "22%",
      wrap: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Голланд</span>,
      selector: (row) => formatHolland(row),
      sortable: false,
      width: "24%",
      wrap: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Действия</span>,
      sortable: false,
      width: "10%",
      center: true,
      compact: true,
      cell: (cellProps) => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-outline-secondary btn-sm d-flex justify-content-center"
              tag="button"
            >
              <TbSettings size={18} />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                className="edit-item-btn"
                onClick={() => toggleModal(cellProps)}
              >
                <TbEdit size={16} className="me-2" />
                Изменить
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  const submitSearch = () => {
    onSearch(searchRef.current.value);
  };

  return (
    <>
      <div className={styles.search}>
        <input
          type="text"
          placeholder="Поиск по тексту"
          ref={searchRef}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              submitSearch();
            }
          }}
        />
        <div
          className={`btn btn-outline-secondary ${styles.btn}`}
          onClick={submitSearch}
        >
          <IoMdSearch size={25} />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        progressComponent={<ClipLoader />}
        progressPending={load}
        paginationTotalRows={total}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pagination
        paginationServer
        paginationComponentOptions={paginationOptions}
      />
    </>
  );
}

export default Table;
